var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: _vm.dialogWidth },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "resizable-card",
          class: { "no-select": _vm.resizing },
          style: { height: _vm.dialogHeight + "px" },
        },
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [_vm._v("Reward Config")]),
          ]),
          _c(
            "v-card-text",
            { staticClass: "resizable-card__body" },
            [
              _c(
                "v-row",
                { staticClass: "mt-4", attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "Key" },
                        model: {
                          value: _vm.model.key,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "key",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.key",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.config.days
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12", md: "2", sm: "2" } },
                        [
                          _c("v-text-field", {
                            attrs: { label: "Days" },
                            model: {
                              value: _vm.model.points,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "points", _vm._n($$v))
                              },
                              expression: "model.points",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.config.points
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12", md: "2", sm: "2" } },
                        [
                          _c("v-text-field", {
                            attrs: { label: "Points" },
                            model: {
                              value: _vm.model.points,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "points", _vm._n($$v))
                              },
                              expression: "model.points",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.config.percent
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12", md: "2", sm: "2" } },
                        [
                          _c("v-slider", {
                            attrs: { label: "Percent", "thumb-label": "" },
                            model: {
                              value: _vm.model.percent,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "percent", $$v)
                              },
                              expression: "model.percent",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.config.productGroups.length > 0
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12", md: "4", sm: "4" } },
                        [
                          _c("r-product-dropdown", {
                            attrs: {
                              model: _vm.model.product,
                              groups: _vm.config.productGroups,
                              clearable: true,
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(_vm.model, "product", $event)
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c("r-reward-view", {
                    attrs: { model: _vm.model },
                    on: {
                      "update:model": function ($event) {
                        _vm.model = $event
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "resizable-card__actions" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
          _c("div", {
            staticClass: "resize-handle",
            on: { mousedown: _vm.startResize },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }